import { CommonModule } from '@angular/common';
import { Component, ElementRef } from '@angular/core';

import type { DialogComponentI } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-wysiwyg-full-screen-dialog',
  imports: [CommonModule],
  template: ``,
})
export class FullScreenDialogComponent implements DialogComponentI<void, void> {
  public get element() {
    return this.elementRef.nativeElement;
  }

  constructor(private elementRef: ElementRef<Element>) {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: void, triggerUpdate: boolean) {}
}
